import { useIntl } from '@/intl'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { AlternativeFilters } from '@/scopes/prices/components/AlternativeFilters/AlternativeFilters'
import { Grid } from '@/scopes/prices/components/Grid'
import { useGridTabsContext } from '@/scopes/prices/components/GridTabsContext'
import { Legend } from '@/scopes/prices/components/Legend'
import { Messages } from '@/scopes/prices/components/Messages'
import { Navigation } from '@/scopes/prices/components/Navigation'
import { PriceBasket } from '@/scopes/prices/components/PriceBasket'
import { PriceBasketLegacy } from '@/scopes/prices/components/PriceBasketLegacy'
import { RoomSelector } from '@/scopes/prices/components/RoomSelector/RoomSelector'
import { RoomSelectorLegacy } from '@/scopes/prices/components/RoomSelectorLegacy/RoomSelectorLegacy'
import {
  getFiltersSelector,
  getTransportSelector,
  isPriceTableLoadingStateSelector,
  pricesResponseSelector,
} from '@/scopes/prices/components/selectors'
import { TransportSelector } from '@/scopes/prices/components/TransportSelector'
import { TransportSelectorLegacy } from '@/scopes/prices/components/TransportSelectorLegacy'
import { useScrollToSection } from '@/scopes/prices/domain/prices/hooks'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { UnavailableContentDialog } from '@sunwebgroup/ui-components'
import * as React from 'react'

export function PriceConfigurator() {
  const intl = useIntl()
  const { selectedTab } = useGridTabsContext()
  const { isEmpty, error } = usePricesSelector(getFiltersSelector)
  const { alternativeFilters } = usePricesSelector(pricesResponseSelector)
  const isLoading = usePricesSelector(isPriceTableLoadingStateSelector)
  const { loading: fetchingTransport } = usePricesSelector(getTransportSelector)
  const ENABLE_UDS_PRICE_SUMMARY = useFeatureFlag('ENABLE_UDS_PRICE_SUMMARY')
  const enableUdsRoomSelector = useFeatureFlag('ENABLE_UDS_ROOM_SELECTOR')
  const ENABLE_UDS_TRANSPORT_SELECTOR = useFeatureFlag('ENABLE_UDS_TRANSPORT_SELECTOR')
  useScrollToSection(isLoading, 'RoomSelector')
  useScrollToSection(fetchingTransport, 'FlightSelector')

  if (selectedTab === 'alertService' || error)
    return null

  if (isEmpty) {
    return (
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'prices_filters_no-results_title' })}
        message={intl.formatMessage({ id: 'prices_filters_no-results_message' })}
      />
    )
  }
  return (
    <>
      {alternativeFilters
        ? (
            <AlternativeFilters />
          )
        : (
            <>
              <Messages />
              <Navigation />
              <Grid />
              <Legend />
              {enableUdsRoomSelector ? (<RoomSelector />) : (<RoomSelectorLegacy />)}
              {ENABLE_UDS_TRANSPORT_SELECTOR ? (<TransportSelector />) : (<TransportSelectorLegacy />)}
              { ENABLE_UDS_PRICE_SUMMARY ? <PriceBasket /> : <PriceBasketLegacy />}
            </>
          )}
    </>
  )
}
